import i18n from '@/i18n';
import { SENS_VENTE } from '@/configuration/devisConf';

export default function formatCodeRemiseBancaire(id, name, sens) {
  if (id === undefined) {
    return '';
  }
  const number = id.toString().padStart(7, '0');
  if (sens === SENS_VENTE) {
    if (name === '' || name === null) {
      return i18n.t('remiseBancaire.remiseN') + number;
    }
    return i18n.t('remiseBancaire.remise') + ' ' + name + ' - N° ' + number;
  }
  if (name === '' || name === null) return i18n.t('listeLotPaiement.lotN') + number;
  return name + ' - N° ' + number;
}
